import * as React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const propTypes = {
  idForm: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  hint: PropTypes.string,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
};

const defaultProps = {
  idForm: false,
  name: '',
  type: 'text',
  value: '',
  onChange: null,
  hint: '',
  error: false,
  placeholder: '',
  className: '',
  autoComplete: '',
};
// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
const regExEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

class FormInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.parseValue(this.props.value),
    };
    this.parseValue = this.parseValue.bind(this);
    this.handlerChange = this.handlerChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const { value } = this.state;
    if (value !== nextProps.value) {
      this.setState({ value: nextProps.value });
      return true;
    }
    return false;
  }

  parseValue(value) {
    const type = typeof this.props.value;
    const valueType = typeof value;
    if (type === valueType) {
      return value;
    } else if (type === 'number') {
      return parseInt(valueType, 10);
    }
    return value.toString();
  }

  handlerChange(e) {
    const value = this.parseValue(e.target.value);
    this.setState({ value });
    if (this.props.onChange) {
      e.target.value = this.parseValue(value);
      this.props.onChange(e);
    }
  }

  render() {
    const {
      idForm,
      type,
      name,
      hint,
      error,
      placeholder,
      autoComplete,
      className,
    } = this.props;
    const { value } = this.state;
    let mType = type;
    if (idForm) {
      if (regExEmail.test(value) || value.indexOf('@') >= 1) {
        mType = 'email';
      } else {
        mType = 'text';
      }
    }

    return (
      <div className={classNames('name', { error })}>
        <input
          type={mType}
          name={name}
          value={value}
          className={className}
          placeholder={placeholder}
          onChange={this.handlerChange}
          autoComplete={autoComplete}
          autoFocus
        />
        {hint !== '' && <p className="hint">{hint}</p>}
      </div>
    );
  }
}

FormInput.propTypes = propTypes;
FormInput.defaultProps = defaultProps;

export default FormInput;
